module.exports = __webpack_public_path__ + "img/LandingPage-Collection.62e9706a.png";